import { useEffect, useState } from 'react';
import styles from './tickets.module.css';
import { motion } from 'framer-motion';
import {useDispatch, useSelector} from 'react-redux';
import {fetchTickets, selectTickets} from '../../store/ticketSlice';
import {event} from 'react-ga';
import {HeaderBack, ListTicket} from 'src/components';
import {EVENT} from "../../config/analytics";
import {trackPage} from "../../utils/track";
import {AppDispatch} from "../../store/store";
import {selectAuth} from "../../store/userSlice";

export interface ITicket {
	open: Array<{ title: string; cdate: string; uuid: string }>;
	resolved: Array<{ title: string; cdate; uuid: string }>;
}

const TicketsPage = () => {
	const tickets = useSelector(selectTickets);
	const auth = useSelector(selectAuth);
	const dispatch = useDispatch<AppDispatch>();
	const [typeOfTicket, setTypeOfTicket] = useState<'open' | 'resolved'>('open');

	const handleTypeOfTicket = (type: 'open' | 'resolved'): void => {
		setTypeOfTicket(type);
	};

	useEffect(() => {
		trackPage({ page: '/tickets' });
		event({category: EVENT.navigation.category, action: EVENT.navigation.actions.mis_tickets});
	}, []);

	useEffect(() => {
		console.log('[HC][TicketsPage] auth token changed', {
			hasToken: !!auth?.token
		});
		if (auth?.token) {
			console.log('[HC][TicketsPage] dispatch fetchTickets');
			dispatch(fetchTickets());
		} else {
			console.log('[HC][TicketsPage] waiting for auth token before fetchTickets');
		}
	}, [auth?.token, dispatch]);

	return (
		<div className={styles.ticketPage}>
			<HeaderBack title="Mis tickets"/>
			<ul className={styles.typeOfTicket}>
				<motion.div
					className={styles.switch}
					animate={typeOfTicket}
					transition={{ duration: 0.3 }}
					variants={{
						open: { left: 0, right: 'auto' },
						resolved: { right: 0, left: 'auto' }
					}}
				/>
				<li className={typeOfTicket === 'open' ? styles.textWhite : ''} onClick={() => handleTypeOfTicket('open')}>
					<b>En proceso</b>
				</li>
				<li
					className={typeOfTicket === 'resolved' ? styles.textWhite : ''}
					onClick={() => handleTypeOfTicket('resolved')}
				>
					<b>Resueltos</b>
				</li>
			</ul>
			<ListTicket tickets={tickets[typeOfTicket]} />
		</div>
	);
};

export default TicketsPage;
